var React = require('react');

function Open (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.42 0.419921L6 4.99992L10.59 0.419922L12 1.82992L6 7.82992L-6.16331e-08 1.82992L1.42 0.419921Z","fill":"#423D33"}));
}

Open.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = Open;

Open.default = Open;
